import { HotelBedData } from '../shared/index';
import { LOCAL_STORAGE_KEY_HOTEL_FILTER, LOCAL_STORAGE_KEY_HOTEL_EXT_FILTER } from '../core/Const';
import { isNull } from '../utils/index';
/**
 * restore data hotel dari local storage
 */
export function readHotelFilterFromStorage(): HotelBedData.SearchFilter | any {
    let storedVal: string | any = localStorage.getItem(LOCAL_STORAGE_KEY_HOTEL_FILTER);
    if (isNull(storedVal)) {
        return null;
    }
    return JSON.parse(storedVal);
}

export function readHotelExtFilterFromStorage(): HotelBedData.ExternalFilter | any {
    let storedVal: string | any = localStorage.getItem(LOCAL_STORAGE_KEY_HOTEL_EXT_FILTER);
    if (isNull(storedVal)) {
        return null;
    }
    return JSON.parse(storedVal);
}

/**
 * worker untuk menulis data filter ke localstorage
 */
export function writeHotelFilterFromStorage(data: HotelBedData.SearchFilter) {
    let strVal = '';
    if (!isNull(data)) {
        strVal = JSON.stringify(data);
    }
    localStorage.setItem(LOCAL_STORAGE_KEY_HOTEL_FILTER, strVal);
}

/**
 * worker untuk menulis data filter ke localstorage
 */
export function writeHotelExtFilterFromStorage(data: HotelBedData.ExternalFilter) {
    let strVal = '';
    if (!isNull(data)) {
        strVal = JSON.stringify(data);
    }
    localStorage.setItem(LOCAL_STORAGE_KEY_HOTEL_EXT_FILTER, strVal);

}

/**
 * 
 */
export interface RecieveHotelDetailDataControl {
    /**
     * handler pada saat data hotel di terima
     */
    (hotel: HotelBedData.Hotel): void;
}

/**
 * manaer untuk penerima data hotel
 */
export class RecieveHotelDetailDataControlManager {
    /**
     * untuk counter id counter
     */
    private registrarIdCounter: number = 0;
    /**
     * handler. di index dengan hote code
     */
    private handlers: { [id: number]: RecieveHotelDetailDataControl[] } = {};
    private byCodeIndexer: { [id: string]: any } = {};
    /**
     * unreg event handler pada saat detach
     * @param id 
     */
    unregisterHandler(id: string) {
        if (!this.byCodeIndexer[id]) {
            return;
        }
        let hdlr: any = this.byCodeIndexer[id];
        delete this.byCodeIndexer[id];
        if (id.indexOf('-') < 0) {
            return;
        }
        const splCOde: string[] = id.split('-');
        const htlCode: number = (splCOde[0] as any) / 1;
        if (this.handlers[htlCode] && this.handlers[htlCode].indexOf(hdlr) >= 0) {
            this.handlers[htlCode].splice(this.handlers[htlCode].indexOf(hdlr), 1);
        }
    }
    /**
     * register handler pemerima data
     * @param hotelCode kode  hotel yang di listen
     * @param handler handler penerima data
     */
    registerHandler(hotelCode: number, handler: RecieveHotelDetailDataControl): string {
        if (!this.handlers[hotelCode]) {
            this.handlers[hotelCode] = [];
        }
        if (this.handlers[hotelCode].indexOf(handler) < 0) {
            this.handlers[hotelCode].push(handler);
            const keys: string[] = Object.keys(this.byCodeIndexer);
            for (let key of keys) {
                if (this.byCodeIndexer[key] === handler) {
                    return key;
                }
            }
        }
        let id: string = `${hotelCode}-${this.registrarIdCounter}`;
        this.registrarIdCounter += 1;
        this.byCodeIndexer[id] = handler;
        return id;
    }
    /**
     * push data hotel ke dalam manager. untuk di publish ke semua reciever
     * @param hotels 
     */
    pushHotelDetailData(hotels: HotelBedData.Hotel[]) {
        if (!hotels || hotels.length === 0) {
            return;
        }
        for (let h of hotels) {
            let htlCode: number = (h as any).hotelCode;
            if (this.handlers[htlCode!] && this.handlers[htlCode!].length > 0) {
                for (let hdl of this.handlers[htlCode!]) {
                    hdl(h);
                }
            }
        }
    }

}


// WEBPACK FOOTER //
// ./src/hotels/hotel-common-utils.ts